import { Box, Modal, Stack, Typography } from '@mui/material';
import React from 'react';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50vw',
  bgcolor: 'background.paper',
  borderRadius: '22px',
  //   border: '2px solid #000',
  boxShadow: 24,
  p: 4
};

const CusModal = ({ open, setOpen, title, content, onClose, sx }) => {
  return (
    <Modal
      open={open}
      onClose={() => {
        if (onClose) {
          onClose();
        }
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{ ...style, ...sx }}>
        <Stack spacing={2}>
          <Typography id="modal-modal-title" variant="h3" component="h2">
            {title}
          </Typography>
          {content}
        </Stack>
      </Box>
    </Modal>
  );
};

export default CusModal;
